import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { passwordMatchValidator, passwordNotContainUsernameValidator, passwordNotSameAsOldValidator } from '@function/password-validator.function';
import { TranslateService } from '@ngx-translate/core';
import { HelperFunctions } from '@service/helper-functions';
import { LoginComponent } from 'src/app/pages/login/login.component';
import { PartnerServicesService } from 'src/app/services/partner-service/partner-services.service';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  tab = 1;
  resetPasswordForm: FormGroup;
  submitTriggered = false;
  inProgress = false;
  mismatch = false;
  created = false;
  passwordVisibility = {
    old_pin: false,
    new_pin: false,
    confirm_pin: false
  };
  constructor(
    private router: Router,
    private userService:  UserManagerService,
    private partnerService: PartnerServicesService,
    private helperFunction: HelperFunctions,
    public dialogRef: MatDialogRef<LoginComponent>,
    private translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
    get rpf() {
      return this.resetPasswordForm.controls;
    }
  ngOnInit() {
    this.resetPasswordForm = new FormGroup({
      old_pin: new FormControl('', [Validators.minLength(2), Validators.required]),
      new_pin: new FormControl('', [Validators.minLength(8), Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$')]),
      confirm_pin: new FormControl('', [Validators.minLength(8), Validators.required]),
    },
    {
      validators: [
        passwordMatchValidator(),
        passwordNotSameAsOldValidator(),
        passwordNotContainUsernameValidator(this.data.login),
      ]
    });
    this.router.events.subscribe(val => {
      this.onNoClick();
    });
  }

  getErrorMessage(controlName: string): string | null {
  const control = this.resetPasswordForm.get(controlName);

  if (!control) {
    return null;
  }

  if (control.errors) {
    if (control.errors.required) {
      return 'field_required';
    }

    if (control.errors.minlength) {
      return 'password_min_length';
    }

    if (control.errors.pattern) {
      return 'password_complexity';
    }
  }

  if (controlName === 'new_pin' && this.resetPasswordForm.errors) {
    if (this.resetPasswordForm.errors.sameAsOld) {
      return 'password_same_as_old';
    }

    if (this.resetPasswordForm.errors.containsUsername) {
      return 'password_contains_username';
    }
  }

  if (controlName === 'confirm_pin' && this.resetPasswordForm.errors) {
    if (this.resetPasswordForm.errors.passwordMismatch) {
      return 'password_mismatch';
    }
  }

  return null;
}

shouldShowError(controlName: string): boolean {
  const control = this.resetPasswordForm.get(controlName);

  if (!control) {
    return false;
  }

  const touchedOrSubmitted = control.touched || this.submitTriggered;
  const hasControlErrors = !!control.errors;
  const hasGroupErrors =
    (controlName === 'new_pin' || controlName === 'confirm_pin') &&
    !!this.resetPasswordForm.errors;

  return touchedOrSubmitted && (hasControlErrors || hasGroupErrors);
}

 toggleVisibility(field: string) {
  this.passwordVisibility[field] = !this.passwordVisibility[field];
}

confirmPass() {
  const pass = this.resetPasswordForm.value;

  if (pass.new_pin !== pass.confirm_pin) {
      this.mismatch = true;
      return;
    } else {
      this.mismatch = false;
    }
}

  resetPassword() {
    this.submitTriggered = true;
    if (!this.resetPasswordForm.valid) {
      return;
    }
    const pass = this.resetPasswordForm.value;

    if (pass.new_pin !== pass.confirm_pin) {
      this.mismatch = true;
      return;
    }
    this.inProgress = false;
    const param = {
      login: this.data.login,
      oldPassword: pass.old_pin,
      newPassword: pass.new_pin,
    };
    // confirmPassword: pass.confirm_pin
    this.helperFunction.presentAlert('warning', this.translate.instant('confirm') + '?', '', this.translate.instant('ml_confirm_change_password') )
    .then((result) => {
      if(result.value) {
        this.helperFunction.presentAlertLoader();
        this.userService.changePassword(param).then(data => {
           this.helperFunction.close();
          this.inProgress = false;
          this.partnerService.checkOperation(data).then(res => {
            if(res == true) {
              this.userService.logoutAgent();
              this.onNoClick()
            }
          });
        }).catch(e =>{
          this.inProgress = false;
           this.helperFunction.close();
          this.helperFunction.presentAlert('error', this.translate.instant('failed'), this.translate.instant('something_went_wrong'), null, null);
        }).finally(() =>{
          this.inProgress = false;
        })

      }
    }

    )
  }
  onNoClick(): void {
    this.dialogRef.close(this.created);
  }
}
